import React, { useEffect, useState } from "react";

const DarkModeToggle = () => {
  const [dark, setDark] = useState(() => {
    const saved = localStorage.getItem('darkMode');
    if (saved !== null) return saved === 'true';
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  useEffect(() => {
    document.body.classList.toggle('dark-mode', dark);
    localStorage.setItem('darkMode', dark);
  }, [dark]);

  return (
    <button
      onClick={() => setDark(d => !d)}
      style={{
        position: "fixed",
        bottom: 24,
        right: 24,
        zIndex: 1000,
        border: "none",
        borderRadius: "50%",
        width: 48,
        height: 48,
        fontSize: 24,
        background: dark ? "#222c37" : "#f1f1f1",
        color: dark ? "#f1f1f1" : "#222c37",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        cursor: "pointer"
      }}
      aria-label="Toggle dark mode"
    >
      {dark ? "🌙" : "☀️"}
    </button>
  );
};

export default DarkModeToggle;